import PositionBusIconRulesService from 'js/services/position-bus-icon-rules.js'

export default {
  data() {
    return {
      // Información de próximos buses en punto más cercano
      nextBuses: undefined,
      // Punto de la ruta más cercano
      routePoint: undefined,
      // Marcador del punto más cercano de la ruta
      routePointMarker: undefined
    }
  },
  methods: {
    /*
     * Método que almacena el marcador de posición del usuario
     */
    associateRoutePoint(marker) {
      const vm = this
      vm.routePointMarker = marker
      vm.map = marker.target._map; // eslint-disable-line
      if (vm.routePoint) {
        vm.centerMap(vm.routePoint)
        vm.onRoutePointClick(vm.routePointMarker)
      }
    },

    routePointIcon() {
      const icon = require('assets/images/map/near-point.png'); // eslint-disable-line

      const PointIcon = L.Icon.extend({
        options: {
          data: null,
          iconUrl: icon,
          className: 'leaflet-nearPosition',
          iconAnchor: [18, 13]
        }
      })

      return new PointIcon({})
    },

    onRoutePointClick(element) {
      const vm = this

      const popupTemplate = require('./route-point-popup.pug'); // eslint-disable-line

      // Si no hay un popup previo asociado
      // con la parada creamos uno nuevo
      if (!element.target.popup) {
        const nextBus = vm.nextBuses[0]

        let distanceValue = 0
        let distanceText

        if (vm.routePoint.distance >= 1000) {
          distanceValue = Vue.options.filters.moverickNumber(vm.routePoint.distance / 1000)
          distanceText = vm.$t('map.distanceTextKilometers', {distance: distanceValue})
        } else {
          distanceValue = Vue.options.filters.moverickNumber(vm.routePoint.distance)
          distanceText = vm.$t('map.distanceTextMeters', {distance: distanceValue})
        }

        const popupData = {
          nextBusPlate: nextBus.bus_plate,
          nextBusTime: vm.nextBusText(nextBus.real_time),
          nextBusAccessible: PositionBusIconRulesService.isAccessible(nextBus),
          nextBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(nextBus),
          nextBusOccupancyImg: PositionBusIconRulesService.occupancyImg(nextBus),
          nextBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
            nextBus
          ),
          nextBusSanitized: PositionBusIconRulesService.isSanitized(nextBus),
          accessibleTranslation: PositionBusIconRulesService.accessibleTranslation(),
          sanitizedTranslation: PositionBusIconRulesService.sanitizedTranslation(),
          distanceText,
          arrivingText: vm.$t('map.arriving')
        }

        const popup = L.popup({
          closeButton: false,
          offset: L.point(0, -7)
        }).setContent(popupTemplate(popupData))

        element.target.unbindPopup()
        element.target.bindPopup(popup).openPopup()
      } else {
        // Si ya hay un popup simplemente lo volvemos a abrir
        element.target.popup.openPopup()
      }
    }
  }
}
